const loaderScript = Array.from(
  document.querySelectorAll("script[data-kk-deferred-product-sections]"),
).find((script) => script.dataset.kkDeferredProductSectionsReady !== "true");

if (loaderScript) {
  loaderScript.dataset.kkDeferredProductSectionsReady = "true";

  const entries = [
    {
      label: "product recommendations",
      moduleUrl: loaderScript.dataset.productRecommendationsModule,
      selector: "[data-product-recommendations]",
      modulePromise: null,
    },
    {
      label: "recently viewed products",
      moduleUrl: loaderScript.dataset.recentlyViewedModule,
      selector: "[data-recently-viewed-container]",
      modulePromise: null,
    },
  ].filter((entry) => entry.moduleUrl);

  const loadModule = (entry) => {
    if (!entry.modulePromise) {
      const modulePromise = import(entry.moduleUrl).catch((error) => {
        if (entry.modulePromise === modulePromise) {
          entry.modulePromise = null;
        }
        console.warn(`Deferred ${entry.label} module failed to load.`, error);
        return null;
      });

      entry.modulePromise = modulePromise;
    }

    return entry.modulePromise;
  };

  const findTargets = (entry, scope = document) => {
    const targets = [];

    if (scope instanceof Element && scope.matches(entry.selector)) {
      targets.push(scope);
    }

    targets.push(...scope.querySelectorAll(entry.selector));
    return targets;
  };

  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  if (isDesignMode || !("IntersectionObserver" in window)) {
    entries.forEach((entry) => {
      if (findTargets(entry).length > 0) {
        void loadModule(entry);
      }
    });
  } else {
    const entriesByTarget = new Map();
    const observer = new IntersectionObserver(
      (records) => {
        records.forEach((record) => {
          if (!record.isIntersecting) return;

          const entry = entriesByTarget.get(record.target);
          if (entry) {
            void loadModule(entry).then((loadedModule) => {
              if (!loadedModule) return;

              observer.unobserve(record.target);
              entriesByTarget.delete(record.target);
            });
          }
        });
      },
      {
        rootMargin: "1200px 0px",
        threshold: 0,
      },
    );

    const observeEntry = (entry, scope = document) => {
      findTargets(entry, scope).forEach((target) => {
        const observationTarget = target.closest(".shopify-section") || target;

        if (entriesByTarget.has(observationTarget)) return;

        entriesByTarget.set(observationTarget, entry);
        observer.observe(observationTarget);
      });
    };

    entries.forEach((entry) => observeEntry(entry));

    document.addEventListener("shopify:section:load", (event) => {
      entries.forEach((entry) => {
        const targets = findTargets(entry, event.target);

        if (targets.length === 0) return;

        if (window.Shopify && window.Shopify.designMode) {
          void loadModule(entry);
          return;
        }

        observeEntry(entry, event.target);
      });
    });
  }

  window.addEventListener("online", () => {
    entries.forEach((entry) => {
      if (!entry.modulePromise && findTargets(entry).length > 0) {
        void loadModule(entry);
      }
    });
  });
}
